module.exports = __webpack_public_path__ + "static/img/newPrice_1.4e7df27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newPrice_1.jpg
// module id = 4ANR
// module chunks = 1